import script from "./MindmapSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./MindmapSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./MindmapSidebar.vue?vue&type=style&index=0&id=1abdbc32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1abdbc32"]])

export default __exports__